import React, { useRef, useState, useEffect, useCallback } from 'react'
import { extend, useFrame } from '@react-three/fiber'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import { Image, useScroll } from '@react-three/drei'
import * as THREE from 'three'
import App from '../../../css/App.scss'
import '../../../css/threejs/ReleaseItem3D.scss'
import work from '../public/Work Sans_Regular.json'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { useSpotify } from '../../../contexts/SpotifyProvider'
import { useNavigate } from 'react-router'

extend({ TextGeometry })

export default function ReleaseItem3D(props) {
    let { index, position, scale, release, totalLength } = props
    const url = release?.images[1]?.url
    const [releaseName] = useState(
        release?.name.length > 20 ? release?.name.substring(0, 20) + '...' : release?.name
    )

    const damp = THREE.MathUtils.damp
    const scroll = useScroll()
    const [hovered, setHovered] = useState(false)

    //refs
    const releaseContainer = useRef()
    const releaseImage = useRef()
    const titleRef = useRef()

    //font
    const font = new FontLoader().parse(work)

    //price
    const [price, setPrice] = useState(0)
    const { generatedAlbumPrices } = useSpotify()

    const over = () => setHovered(true)
    const out = () => setHovered(false)

    const navigate = useNavigate()

    const handleReleaseItem = useCallback(() => {
        navigate(`/releaseDetails/${release?.id}`)
    }, [navigate, release])

    useFrame((state, delta) => {
        const scrollValue = scroll.curve(index / totalLength - 1.5 / totalLength, 4 / totalLength)

        if (hovered) releaseImage.current.scale.x = damp(releaseImage.current.scale.x, 300, 6, delta)
        if (hovered) releaseImage.current.scale.y = damp(releaseImage.current.scale.y, 300, 6, delta)

        releaseImage.current.scale[0] = releaseImage.current.scale.x = damp(releaseImage.current.scale.x, scale[0] * .6 + scrollValue * 75, 8, delta)
        releaseImage.current.scale[1] = releaseImage.current.scale.y = damp(releaseImage.current.scale.y, scale[1] * .6 + scrollValue * 75, 8, delta)
    })

    useEffect(() => {
        // Get Price
        const priceCurrentAlbum = generatedAlbumPrices.find(item => item.id === release?.id) || {}
        setPrice(priceCurrentAlbum.price)
    }, [generatedAlbumPrices])

    // Set cursor
    useEffect(() => {
        document.body.style.cursor = hovered ? 'pointer' : 'auto'
    }, [hovered])

    return (
        <group ref={releaseContainer} position={position}>
            <Image ref={releaseImage} scale={scale} url={url} onClick={handleReleaseItem} onPointerOver={over} onPointerOut={out} />
            {
                hovered ? (
                    <group>
                        <mesh ref={titleRef} position={[-150, 150, 0]}>
                            <textGeometry args={[releaseName, { font, size: 15, height: 1 }]} />
                            <meshPhysicalMaterial attach='material' color={App.secondaryColor} />
                        </mesh>
                        <mesh position={[100, 150, 0]}>
                            <textGeometry args={[`€ ${price}`, { font, size: 12, height: 1 }]} />
                            <meshPhysicalMaterial attach='material' color={App.secondaryColor} />
                        </mesh>
                    </group>
                ) : (
                    null
                )
            }
        </group>
    )
}